// @flow

import styled, { css } from 'styled-components';
import { px, py } from 'styled-components-spacing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import theme from '@theme';

// Filter Styles
const activeFilterWrapperStyles = css`
  position: fixed;
  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  background-color: ${theme.colors.white};
`;

export const StyledFilterWrapper = styled.div`
  ${({ isActive }) => isActive && activeFilterWrapperStyles}

  display: flex;
  flex-direction: column;
`;

export const StyledFilterBody = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const StyledFilterHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${px(3)}
  ${py(2.5)}
`;

export const StyledFilterIcon = styled(FontAwesomeIcon)`
  color: ${theme.colors.darkBlue};
`;

export const StyledFilterCollapsed = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  background-color: ${theme.colors.white};

  ${px(3)}
  ${py(2.5)}
`;

export const StyledFilterStatus = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const StyledFilterLabel = styled.div`
  font-weight: bold;
  font-size: 16px;
  color: ${theme.colors.darkBlue};
`;

export const StyledFilterValue = styled.p`
  font-weight: normal;
  font-size: 18px;
  color: ${theme.colors.darkBlue};
`;

export const StyledFilterBackButton = styled(FontAwesomeIcon)`
  color: ${theme.colors.aquaMarine};
`;

export const StyledFilterHeaderLabel = styled.p`
  flex: 1;
  text-align: center;

  font-size: 20px;
  font-family: Raleway;
  font-weight: bold;
  line-height: 40px;

  color: ${theme.colors.darkBlue};
`;
